import { Button } from '@/ui/button/button';
import { CreateDropdown } from './create-dropdown';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export const CreateDropdownWithButton = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { t } = useTranslation('projects');

  const toggleDropdownMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <CreateDropdown
      triggerButton={
        <Button
          variant="secondary"
          startIcon="Plus"
          onClick={toggleDropdownMenu}
        >{t`Create`}</Button>
      }
      options={{
        placement: 'bottom-end',
      }}
      setIsDropdownOpen={setIsOpen}
    />
  );
};
